import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/minus.svg'
import _imports_1 from '../../assets/caprock/images/plus.svg'
import _imports_2 from '../../assets/caprock/images/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-d6fb6c72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row my-3 justify-content-center" }
const _hoisted_2 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "login-body company" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-md-12 col-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { style: {"color":"grey","font-family":"'Merriweather'"} }
const _hoisted_9 = { class: "col-md-12 col-12" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-dark" }, "Name", -1))
const _hoisted_12 = { class: "col-md-12 col-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-dark" }, "Swift Code", -1))
const _hoisted_15 = { class: "col-md-12 col-12" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-dark" }, "Address", -1))
const _hoisted_18 = { class: "col-md-12 col-12" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "BSB (Australian Customers Only)", -1))
const _hoisted_21 = { class: "col-md-12 col-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-dark" }, "Account Number or IBAN", -1))
const _hoisted_24 = { class: "col-md-12 col-12" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-dark" }, "Currency", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-md-12 col-12" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "A Copy of your bank statement or bank account veriication letter from your bank", -1))
const _hoisted_32 = {
  key: 0,
  class: "progress"
}
const _hoisted_33 = ["aria-valuenow"]
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" If your bank account details have changed, you will need to remove your existing bank account from your Platform Cash Account and add your new bank account. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" We only accept bank accounts in your personal/company name. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" All request for withdrawals from your Caprock Merchant Managed Account Platform to your own external bank account are only available to users who added and verified their bank accounts details in this step. You may add more than 1 Bank Account in multiple currencies by clicking on add account above. ")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile mt-3 btn-mobile font-size-15-18"
  }, " Save Account ")
], -1))
const _hoisted_38 = {
  key: 1,
  class: "row my-3 justify-content-center"
}
const _hoisted_39 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_40 = { class: "login-card" }
const _hoisted_41 = { class: "login-body company" }
const _hoisted_42 = { class: "row mt-3" }
const _hoisted_43 = { class: "col-md-12 col-12" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { style: {"color":"grey","font-family":"'Merriweather'"} }
const _hoisted_46 = { class: "col-md-12 col-12 table-responsive" }
const _hoisted_47 = { class: "table table-bordered w-100" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Swift Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Account Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Document"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_2
}, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "No records found", -1))
const _hoisted_57 = [
  _hoisted_56
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.bank_accounts.length==0 || _ctx.show_form==1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          ref: "bank_form",
          id: "bank_form",
          method: "POST",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.save_bank
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h4", _hoisted_8, [
                            _createTextVNode(" Add External Bank Account "),
                            (_ctx.bank_accounts.length>0)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.show_form=0)),
                                  style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                  src: _imports_0
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.bank_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.bank_name) = $event)),
                            placeholder: "i.e. CITI Bank ",
                            class: "form-control selected-field",
                            name: "bank_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.bank_swift_code,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.bank_swift_code) = $event)),
                            placeholder: "i.e. 56783 3234",
                            class: "form-control selected-field",
                            name: "bank_swift_code",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_swift_code"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.bank_address,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.bank_address) = $event)),
                            placeholder: "i.e. Sydney West  ",
                            class: "form-control selected-field",
                            name: "bank_address",
                            type: "text",
                            rules: [_ctx.requiredField]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_address"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.bank_bsb,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.bank_bsb) = $event)),
                            placeholder: "i.e. 8767869",
                            class: "form-control selected-field",
                            name: "bank_bsb",
                            type: "text",
                            rules: []
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_bsb"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.bank_account_no,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.bank_account_no) = $event)),
                            placeholder: "i.e. 2398798 29",
                            class: "form-control selected-field",
                            name: "bank_account_no",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_account_no"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.bank_currency_id,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.bank_currency_id) = $event)),
                            class: "form-control",
                            name: "bank_currency_id",
                            as: "select",
                            rules: _ctx.selectField
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: country.country_id,
                                  value: country.country_id
                                }, _toDisplayString(country.currency) + " - " + _toDisplayString(country.country_name), 9, _hoisted_28))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_currency_id"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_Field, {
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadFile($event))),
                            modelValue: _ctx.form.bank_verification_doc,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.bank_verification_doc) = $event)),
                            class: "form-control selected-field",
                            ref: "bank_doc",
                            name: "bank_verification_doc",
                            type: "file",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          (_ctx.form.bank_verification_doc_pdiv==1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("div", {
                                  class: "progress-bar bg-dark",
                                  role: "progressbar",
                                  style: _normalizeStyle({'width':_ctx.form.bank_verification_doc_pbar+'%'}),
                                  "aria-valuenow": _ctx.form.bank_verification_doc_pbar,
                                  "aria-valuemin": "0",
                                  "aria-valuemax": "100"
                                }, _toDisplayString(_ctx.form.bank_verification_doc_pbar_p), 13, _hoisted_33)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Field, {
                            rules: _ctx.requiredField,
                            modelValue: _ctx.form.bank_verification_doc_path,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.bank_verification_doc_path) = $event)),
                            class: "form-control selected-field",
                            name: "bank_verification_doc_path",
                            type: "hidden"
                          }, null, 8, ["rules", "modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "bank_verification_doc_path"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("h4", {
                          class: "font-grey",
                          style: {"font-family":"Merriweather"},
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                        }, "Note"),
                        _hoisted_36
                      ]),
                      _hoisted_37
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.bank_accounts.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("h4", _hoisted_45, [
                        _createTextVNode(" External Bank Accounts "),
                        _createElementVNode("img", {
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (this.show_form=1)),
                          style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                          src: _imports_1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("table", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bank_accounts, (bank, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: bank.bank_id
                          }, [
                            _createElementVNode("td", _hoisted_49, _toDisplayString(index+1), 1),
                            _createElementVNode("td", null, _toDisplayString(bank['bank_name']), 1),
                            _createElementVNode("td", null, _toDisplayString(bank['bank_swift_code']), 1),
                            _createElementVNode("td", null, _toDisplayString(bank['bank_account_no']), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                target: "_blank",
                                href: bank['bank_verification_doc_url']
                              }, "View", 8, _hoisted_50)
                            ]),
                            _createElementVNode("td", _hoisted_51, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => {_ctx.delete_bank(bank.bank_id);},
                                class: "btn-mobile btn"
                              }, _hoisted_54, 8, _hoisted_52)
                            ])
                          ]))
                        }), 128)),
                        (!_ctx.bank_accounts.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_55, _hoisted_57))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}